import { useState } from 'react';
import { HeartHandshake } from 'lucide-react';
import { Button, cn } from '@ai-tutor/ui';
import { HelplineDialog } from './HelplineDialog';

/**
 * One gentle line for a low or overwhelmed answer: an open door to people,
 * not a wall of phone numbers. The helplines themselves are a tap away, in
 * `HelplineDialog`.
 */
export function SupportPrompt({
  stacked = false,
  className,
}: {
  /** For a narrow column: the line on top, the button under it. */
  stacked?: boolean;
  className?: string;
}) {
  const [open, setOpen] = useState(false);
  return (
    <div
      className={cn(
        'tint-brand flex rounded-xl text-sm',
        stacked
          ? 'flex-col items-start gap-3 p-4'
          : 'flex-wrap items-center justify-between gap-x-4 gap-y-2 py-2 pl-4 pr-2',
        className
      )}
    >
      <span className='flex min-w-0 items-start gap-2'>
        <HeartHandshake
          className='mt-0.5 h-4 w-4 shrink-0'
          aria-hidden='true'
        />
        <span>
          <span className='font-medium'>Need to talk to someone?</span> Free,
          confidential helplines are a tap away.
        </span>
      </span>
      <Button
        type='button'
        size='sm'
        variant='outline'
        className='shrink-0 bg-card max-sm:h-11'
        onClick={() => setOpen(true)}
      >
        Talk to someone
      </Button>
      <HelplineDialog open={open} onClose={() => setOpen(false)} />
    </div>
  );
}
